import * as z from "zod";

const parseAddressSchema = z.object({
  name: z.string().nullable(),
  streetLine1: z.string().nullable(),
  streetLine2: z.string().nullable(),
  city: z.string().nullable(),
  stateOrProvinceCode: z.string().nullable(),
  postalCode: z.string().nullable(),
  countryCode: z.string().nullable(),
});

const invoiceSummaryLineSchema = z.object({
  line: z.string(),
  amount: z.string().nullable(),
  currency: z.string().nullable(),
});

export const fedexInvoiceParseResult = z.object({
  invoiceNumber: z.string().nullable(),
  invoiceDate: z.string().nullable(),
  paymentDueDate: z.string().nullable(),
  accountNumber: z.string().nullable(),
  accountName: z.string().nullable(),
  invoiceAmount: z.string().nullable(),
  invoiceCurrency: z.string().nullable(),
  billingAddress: parseAddressSchema.nullable(),
  shippingAddress: parseAddressSchema.nullable(),
  invoiceSummary: z.array(invoiceSummaryLineSchema).nullable(),
  totalDiscount: z.string().nullable(),
  totalCharges: z.string().nullable(),
});
export type FedexInvoiceParseResult = z.infer<typeof fedexInvoiceParseResult>;

export const parseFedexInvoicePdf = {
  name: "parseFedexInvoicePdf" as const,
  input: z.object({
    fileData: z.string().min(1),
    fileName: z.string().min(1),
    mimeType: z.string().optional(),
  }),
  output: fedexInvoiceParseResult,
};
